import React, { useState } from 'react';
import { Modal, Form, Input, Button, message, } from 'antd';
import emailjs from 'emailjs-com';
// import { useNavigate } from 'react-router-dom';
import './JobOrientedCourses.css';

// Import images for the Job Oriented Courses
import topImage from '../../assets/images/job_oriencr.webp';
import fullStackImage from '../../assets/images/job-oriented-course/fullstack.jpg';
import networkingImage from '../../assets/images/job-oriented-course/datacom.jpg';
import cloudComputingImage from '../../assets/images/job-oriented-course/cloud.jpg';
import competitiveProgrammingImage from '../../assets/images/job-oriented-course/datastructure.jpg';
import pythonDataScienceImage from '../../assets/images/job-oriented-course/python-ds.jpg';
import agileDevOpsImage from '../../assets/images/job-oriented-course/devops.jpg';



const JobOrientedCourses = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm(); // Ant Design form instance
    const [selectedCourse, setSelectedCourse] = useState('');

    // Show the modal for the selected course
    const handleApplyClick = (courseName) => {
        setSelectedCourse(courseName);
        setIsModalVisible(true);
    };

    // Handle form submission
    const handleFormSubmit = (values) => {
        const emailParams = {
            name: values.name,
            email: values.email,
            phone: values.phone,
            selectedCourse: selectedCourse,
        };

        emailjs
            .send(
                'service_oit4bk9', // Replace with your EmailJS service ID
                'template_xny0vd6', // Replace with your EmailJS template ID
                emailParams,
                '6xlgr_2EFvcPEjnDG' // Replace with your EmailJS public key
            )
            .then(
                () => {
                    message.success(`Application submitted for ${selectedCourse}`);
                    setIsModalVisible(false);
                    form.resetFields();
                },
                (error) => {
                    console.error('EmailJS Error:', error);
                    message.error('Failed to submit application. Please try again.');
                }
            );
    };

    return (
        <div className="job-oriented-courses" style={{ paddingTop: '0px' }}>
            <div className="top-image-container">
                <img src={topImage} alt="Job Oriented Courses" className="top-image" />
            </div>

            <h1 style={{ textAlign: 'center' }}>Job Oriented Courses</h1>

            <div className="course-cards" id='full-stack-development'>
                <div className="image-section">
                    <img src={fullStackImage} alt="Full Stack Development" />
                </div>
                <div className="content-section">
                    <h2>Full Stack Development</h2>
                    <p><strong>Course Details:</strong><br />Become a Fullstack Web Developer by mastering HTML, CSS, JavaScript, and PHP. This
course is designed to take you from a beginner to an advanced level, equipping you with the
full set of skills needed to create dynamic, interactive, and fully functional web
applications. Whether you're new to web development or looking to enhance your existing
skills, this course will provide comprehensive knowledge of both front-end and back-end
technologies.</p>
                    <p>This course covers HTML elements, tags, forms, CSS forms, layouts, shadows, responsive
pages, style elements, javascript control flow, functions, error handling, client side
validations, PHP basics, functions, OOPs,super globals, form handling, file handling,
sessions, PHP connectivity with MySQL, PHP validations, Error handling, React JS, State,
Props, postman and HTTP server</p>
                   
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Computer Operating Knowledge</li>
                        <li>Knowledge of programming techniques would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Develop simple web applications using the learnt web development technologies</li>
                        <li>Able to create web portal for various applications of any domain</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Full Stack Development')}>
                        To Register
                    </button>
                </div>
            </div>

            <div className="course-cards" id='datacom-networking'>
                <div className="image-section">
                    <img src={networkingImage} alt="Datacom Networking" />
                </div>
                <div className="content-section">
                    <h2>Datacom Networking</h2>
                    <p><strong>Course Details:</strong><br />Datacom Networking refers to the communication systems and technologies used to transmit data over networks. This field encompasses the design, implementation, management, and troubleshooting of data communication systems, including both hardware and software aspects. Key technologies in datacom networking include Ethernet, IP (Internet Protocol), TCP/IP, routers, switches, firewalls, and wireless networks. This is essential knowledge for setting up and maintaining data infrastructure that supports businesses, organizations, and internet services.</p>
                    <p>This is also called as Front-end Development which is the development or creation of a
                        user interface using some markup languages and other tools. It is basically the development
                        of the user side where only user interaction will be counted. It consists of the interface
                        where buttons, texts, alignments, etc are involved and used by the user.</p>
                    <p>This course will cover the core principles of networking, including how data is transmitted, routed, and secured across local area networks (LANs) and wide area networks (WANs). Topics like IP addressing, subnetting, routing protocols, and network security practices will be explored to give learners a comprehensive understanding of the fundamentals needed to build and maintain a reliable, efficient data communication network.</p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Basic understanding of computer hardware and software.</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Understand the fundamental concepts of data communication and networking.</li>
                        <li>Learn how to configure and manage network devices like routers, switches, and firewalls.</li>
                        <li>Gain knowledge of IP addressing, subnetting, and network security protocols.</li>
                        <li>Develop the skills to troubleshoot and optimize network performance across various environments</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Datacom Networking')}>
                        To Register
                    </button>
                </div>
            </div>


            <div className="course-cards" id='cloud-computing'>
                <div className="image-section">
                    <img src={cloudComputingImage} alt="Cloud Computing" />
                </div>
                <div className="content-section">
                    <h2>Cloud Computing</h2>
                    <p><strong>Course Details:</strong><br />The Cloud computing is one of the hottest areas in information technology today. The
market for Cloud Computing services is exploding and the demand developers with Cloud
Computing Skills Continues to grow. This course covers the basics of cloud computing and
the advantages and limitations of Cloud Computing. In addition, you will get to know to
create free developer accounts with some of the leading cloud computing platforms such
as Amazon AWS, Microsoft Azure and Google Cloud.</p>
                    <p>This training covers the topics that include Linux fundamentals, Linux Fundamentals, AWS
Overview, IAM, EC2, Auto Scaling, Load Balancing, Elastic Block Storage, Object Storage,
Cloud Front, Route 53, Security Management, Virtual Private Cloud, Relational Database,
DynamoDB Monitoring Services, AWS Architecture and DevOps Fundamentals</p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Working knowledge on computer systems</li>
                        <li>Basic knowledge of computer server systems would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Able to monitor and manage resources in AWS to maintain healthy applications and systems</li>
                        <li>Able to set up and maintain networking infrastructure tailored to Amazon AWS, ensuring a solid grasp on cloud-based networking concepts</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Cloud Computing')}>
                        To Register
                    </button>
                </div>
            </div>


            <div className="course-cards" id='competitive-programming'>
                <div className="image-section">
                    <img src={competitiveProgrammingImage} alt="Competitive Programming" />
                </div>
                <div className="content-section">
                    <h2>Datastructure & Algorithms</h2>
                    <p><strong>Course Details:</strong><br />The primary goal of this course is to get prepared for 
                    coding interviews at top tech product companies. The course focuses on training the problem-solving
                    skills with techniques and tips. Consistent practice will equip with the skills required for 
                    coding interviews.Obtaining/Improving a good score on Leetcode is also focussed on this course.
                    </p>
                    <p>This course will cover the basic foundation, time & space complexity, different data structures,
                         mastering the computer science fundamentals, recursion, learn and implement different algorithms 
                         that includes greedy algorithms, binary search, sorting and dynamic programming
                    </p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Computer Operating Knowledge</li>
                        <li>Knowledge of server and operating system would be definitely an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Able to discuss / work on networking projects</li>
                        <li>Able to configure real networking devices such as routers and switches</li>
                        <li>Can be a starter for CCNA certification.</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Competitive Programming')}>
                        To Register
                    </button>
                </div>
            </div> <div className="course-cards" id='python-data-science'>
                <div className="image-section">
                    <img src={pythonDataScienceImage} alt="Python with Data Science" />
                </div>
                <div className="content-section">
                    <h2>Python with Data Science</h2>
                    <p><strong>Course Details:</strong><br />Python has become a popular programming language in the data science community due to
its simplicity, flexibility, and wide range of libraries and tools. With its powerful data
manipulation and analysis capabilities, Python has emerged as the language of choice for
data scientists, machine learning engineers, and analysts. </p>
                    <p>By learning Python, you can effectively clean and manipulate data, create visualizations,
and build machine-learning models. It also has a strong community with a wealth of online
resources and support, making it easier for beginners to learn and get started.  </p>
                    <p>This course starts by learning the basics of python, familiarize with essential data science
libraries like NumPy, Pandas, Matplotlib, basic understanding of statistics and mathematics,
machine learning that includes supervised learning, unsupervised learning, classification,
regression and clustering
</p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Computer Operating Knowledge </li>
                        <li>Knowledge of statistics and probability techniques would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Extract data from various sources like websites, pdf files, csv and RDBMS databases</li>
                        <li>Start making visualizations charts - bar chart , box plots which will give the
                        meaningful insights using Pandas , NumPy and MatPlotlib</li>
                        <li>Learn the art of Data Analysis, Visualizations for Data Science Projects</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Python with Data Science')}>
                        To Register
                    </button>
                </div>
            </div> <div className="course-cards" id='agile-devops'>
                <div className="image-section">
                    <img src={agileDevOpsImage} alt="Agile & DevOps" />
                </div>
                <div className="content-section">
                    <h2>Agile & DevOps</h2>
                    <p><strong>Course Details:</strong><br />The goal of this course will be for regular developers and regular engineering practitioners
to learn fundamental DevOps concepts so that they can go towards the DevOps engineering
role. DevOps is a methodology that helps engineering teams build products better by
continuously integrating user feedback. You will learn what DevOps is, continuous
integration, continuous deployment strategies, and application performance management. </p>
                    <p>The training covers DevOps concepts, SDLC, Test driven development, CI/CD, code coverage,
code review, deployment strategies using VMs, containers, Continuous integration and
deployment, autoscaling and application performance management based on logs and
metrics. This course also covers the usage of docker, Jenkins, Kubernetes, Grafana and
version control system (git, gitlab)
</p>
                    <strong>Prerequisite:</strong>
                    <ul>
                        <li>Knowledge on Linux and familiarity in configuration of service</li>
                        <li>Basic knowledge of coding, testing would be an advantage</li>
                    </ul>
                    <strong>Takeaways:</strong>
                    <ul>
                        <li>Able to implement and manage Continuous Integration and Continuous Delivery
                        (CI/CD) pipelines to automate software and code releases.</li>
                        <li>Able to write and maintain scripts to automate tasks and DevOps processes.</li>
                    </ul>
                    <button className="apply-button" onClick={() => handleApplyClick('Agile & DevOps')}>
                        To Register
                    </button>
                </div>
            </div>



           
            {/* Modal for application form */}
            <Modal
                title={`Apply for ${selectedCourse}`}
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFormSubmit}
                >
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Please enter your name!' }]}
                    >
                        <Input placeholder="Your Name" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: 'Please enter your email!' },
                            { type: 'email', message: 'Please enter a valid email!' },
                        ]}
                    >
                        <Input placeholder="Your Email" />
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="Phone Number"
                        rules={[{ required: true, message: 'Please enter your phone number!' }]}
                    >
                        <Input placeholder="Your Phone Number" />
                    </Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Submit Application
                    </Button>
                </Form>
            </Modal>
        </div>
    );
};

export default JobOrientedCourses;
